import axios from "axios";
import { serverURL, headeroption, headeroptionupload } from "../http-common";
import jwt_decode from "jwt-decode";

class authsService {
  userinfo() {
    if (localStorage.getItem("userinfo") !== null &&
      localStorage.getItem("userinfo") !== undefined &&
      localStorage.getItem("userinfo") !== "") {
      const userData = localStorage.getItem("userinfo");
      // const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9zZ2FpcmNvbi5jb20uc2ciLCJhdWQiOiJodHRwOlwvXC9zZ2FpcmNvbi5jb20uc2ciLCJuYmYiOjE2NzQyMDUxNTcsImlhdCI6MTY3NDIwNTE1MiwiZXhwIjoxNjc0MjA2OTUyLCJyZXN1bHQiOnsidXNlcl9pZCI6MTE3LCJ1c2VyX25hbWUiOiJnaGdoIiwidXNlcl9yb2xlIjoiYWRtaW4ifX0.x3-wZ5tYW2SsrxtfuBOLc-IfJf7Ei-UWlbSMzP-3XsA"
      /* const userinfo = JSON.parse(userData); */
      try {
        var userinfo = JSON.parse(userData);
      } catch (e) {
        return (userinfo = {});
      }
      if (userinfo["token"] !== undefined) {
        const token = userinfo.token;
        const decoded = jwt_decode(token);
        return decoded.result;
      } else {
        const userinfo = {};
        return userinfo;
      }
    } else {
      const userinfo = {};
      return userinfo;
    }
  }
  jwtdecode(token) {
    const decoded = jwt_decode(token);
    return decoded.result;
  }
  userdata() {
    if (localStorage.getItem("userinfo") !== null &&
      localStorage.getItem("userinfo") !== undefined &&
      localStorage.getItem("userinfo") !== "") {
      const userData = localStorage.getItem("userinfo");
      // const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9zZ2FpcmNvbi5jb20uc2ciLCJhdWQiOiJodHRwOlwvXC9zZ2FpcmNvbi5jb20uc2ciLCJuYmYiOjE2NzQyMDUxNTcsImlhdCI6MTY3NDIwNTE1MiwiZXhwIjoxNjc0MjA2OTUyLCJyZXN1bHQiOnsidXNlcl9pZCI6MTE3LCJ1c2VyX25hbWUiOiJnaGdoIiwidXNlcl9yb2xlIjoiYWRtaW4ifX0.x3-wZ5tYW2SsrxtfuBOLc-IfJf7Ei-UWlbSMzP-3XsA"
      /* const userinfo = JSON.parse(userData); */
      try {
        var userinfo = JSON.parse(userData);
      } catch (e) {
        return (userinfo = {});
      }
      // JWT exp is in seconds
      if (userinfo["token"] !== undefined) {
        const decodeds = jwt_decode(userinfo.token);
        var value = decodeds.exp * 1000 > new Date().getTime() ? 1 : 0;
      } else {
        var value = 0;
      }
      /*   const decodeds = jwt_decode(userinfo.token);
        const value = decodeds.exp * 1000 > new Date().getTime() ? 1 : 0; */

      if (userinfo["token"] !== undefined && value === 1) {
        const token = userinfo.token;
        const decoded = jwt_decode(token);
        return {
          user_role: decoded.result.user_role,
          login_type: decoded.result.login_type,
          token: userinfo.token,
        };
      } else {
        localStorage.clear();
        const userinfo = {};
        return userinfo;
      }
    } else {
      const userinfo = {};
      return userinfo;
    }
  }
  getclientname() {
    const ddd = this.userdata();
    if (localStorage.getItem("selectedclient") !== null) {
      return localStorage.getItem("selectedclient");
    } else {
      if (ddd.login_type == "client") {
        return this.userinfo().user_id;
      }else if (ddd.login_type == "technition") {
        return localStorage.getItem("selectedclient");
      } else {
        return "democlient";
      }
    }
  }
  signin(data) {
    return axios.get(serverURL + "/auths-api?req=signin", {
      params: data,
      headers: headeroption,
    });
  }
  signinclient(data) {
    return axios.get(serverURL + "/auths-api?req=signinclient", {
      params: data,
      headers: headeroption,
    });
  }
  signintechnition(data) {
    return axios.get(serverURL + "/auths-api?req=signintechnition", {
      params: data,
      headers: headeroption,
    });
  }
  signup(data) {
    return axios.post(serverURL + "/auths-api?req=signup", data, {
      headers: headeroption,
    });
  }
  getUserProfile(user_id) {
    return axios.get(serverURL + "/auths-api?req=getUserProfile", {
      params: { user_id: user_id },
      headers: headeroption,
    });
  }
  passwordresetverify(data) {
    return axios.get(serverURL + "/auths-api?req=passwordresetverify", {
      params: data,
      headers: headeroption,
    });
  }
  sentpasswordresetlink(data) {
    return axios.get(serverURL + "/email/passwordresetlink", {
      params: data,
      headers: headeroption,
    });
  }
  updatePassword(data) {
    return axios.put(serverURL + "/auths-api?req=updatepassword", data, {
      headers: headeroption,
    });
  }
  updateUser(data) {
    return axios.put(serverURL + "/users-api?req=updateUser", data, {
      headers: headeroption,
    });
  }
  deleteUser(user_id) {
    return axios.delete(serverURL + "/users-api?req=deleteUser", {
      params: { user_id: user_id },
      headers: headeroption,
    });
  }
  deleteAll() {
    return axios.delete(serverURL + "/users-api?req=deleteUser");
  }
  uploadUser(user_id, data) {
    return axios.post(serverURL + "/uploads-api?req=singlefile", data, {
      params: { user_id: user_id },
      headers: headeroptionupload,
    });
  }
  uploadUsers(brand_id, data) {
    return axios.post(`/uploadmultifile/${brand_id}`, data);
  }
}
export default new authsService();
